// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__1xCdK","content":"Modal_content__qziq_"};